<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("TITLES.ad_request_details") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #404b3e">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form>
        <div class="row">
          <!-- Start:: Ad Information Section -->
          <div class="col-12 mb-4">
            <h5
              style="
                color: #404b3e;
                border-bottom: 2px solid #404b3e;
                padding-bottom: 10px;
              "
            >
              {{ $t("TITLES.ad_information") }}
            </h5>
          </div>

          <!-- Start:: Ad Name -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.ad_name')"
            v-model.trim="data.name"
            disabled
          />
          <!-- End:: Ad Name -->

          <!-- Start:: Shop Type -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.shop_type')"
            v-model.trim="data._shop_type"
            disabled
          />
          <!-- End:: Shop Type -->

          <!-- Start:: Area -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.area_wide')"
            v-model.trim="data.area"
            disabled
          />
          <!-- End:: Area -->

          <!-- Start:: Advertiser Type -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.advertiser_type')"
            v-model.trim="data.user.user._landlord_type"
            disabled
          />
          <!-- End:: Advertiser Type -->

          <!-- Start:: Shop Status -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.shop_status')"
            v-model.trim="data._shop_status"
            disabled
          />
          <!-- End:: Shop Status -->

          <!-- Start:: Payment Due -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.payment_due')"
            v-model.trim="data._payment_due"
            disabled
          />
          <!-- End:: Payment Due -->

          <!-- Start:: Allowed Activities -->
          <base-select-input
            v-if="data.allowed_activities && data.allowed_activities.length"
            col="6"
            :placeholder="$t('PLACEHOLDERS.allowed_activities')"
            :optionsList="data.allowed_activities"
            v-model="selectedAllowedActivities"
            multiple
            disabled
          />
          <!-- End:: Allowed Activities -->

          <!-- Start:: Blocked Activities -->
          <base-select-input
            v-if="data.blocked_activities && data.blocked_activities.length"
            col="6"
            :placeholder="$t('PLACEHOLDERS.blocked_activities')"
            :optionsList="data.blocked_activities"
            v-model="selectedBlockedActivities"
            multiple
            disabled
          />
          <!-- End:: Blocked Activities -->

          <!-- Start:: Rent Price -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.rent_price')"
            v-model.trim="data.rent_price"
            disabled
          />
          <!-- End:: Rent Price -->

          <!-- Start:: Status -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.status')"
            v-model.trim="data._ad_status"
            disabled
          />
          <!-- End:: Status -->

          <!-- Start:: Rejection Reason -->
          <base-input
            v-if="data.rejection_reason"
            col="12"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.rejection_reason')"
            v-model.trim="data.rejection_reason"
            disabled
          />
          <!-- End:: Rejection Reason -->

          <!-- Start:: Location Section -->
          <div class="col-12 mt-4 mb-3">
            <h5
              style="
                color: #404b3e;
                border-bottom: 2px solid #404b3e;
                padding-bottom: 10px;
              "
            >
              {{ $t("TITLES.location_information") }}
            </h5>
          </div>

          <!-- Start:: Region -->
          <base-input
            v-if="data.region"
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.region')"
            v-model.trim="data.region.name"
            disabled
          />
          <!-- End:: Region -->

          <!-- Start:: City -->
          <base-input
            v-if="data.city"
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.city')"
            v-model.trim="data.city.name"
            disabled
          />
          <!-- End:: City -->

          <!-- Start:: District -->
          <base-input
            v-if="data.district"
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.district')"
            v-model.trim="data.district.name"
            disabled
          />
          <!-- End:: District -->

          <!-- {{ data.lat }} -->
          <!-- Start:: Map -->
          <div class="col-12 mb-4" v-if="data.lat && data.lng">
            <h6 style="color: #404b3e; margin-bottom: 15px">
              {{ $t("PLACEHOLDERS.location_on_map") }}
            </h6>
            <div style="height: 300px">
              <MapComponent
                :lat="parseFloat(data.lat)"
                :lng="parseFloat(data.lng)"
              />
            </div>
          </div>
          <!-- End:: Map -->

          <!-- Start:: Advertiser Information Section -->
          <div class="col-12 mt-4 mb-3">
            <h5
              style="
                color: #404b3e;
                border-bottom: 2px solid #404b3e;
                padding-bottom: 10px;
              "
            >
              {{ $t("TITLES.advertiser_information") }}
            </h5>
          </div>

          <!-- Start:: Advertiser Name -->
          <base-input
            v-if="data.user && data.user.user"
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.advertiser_name')"
            v-model.trim="data.user.user.name"
            disabled
          />
          <!-- End:: Advertiser Name -->

          <!-- Start:: Advertiser Mobile -->
          <base-input
            v-if="data.user && data.user.user"
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.mobile')"
            v-model.trim="data.user.user.mobile"
            disabled
          />
          <!-- End:: Advertiser Mobile -->

          <!-- Start:: Advertiser Email -->
          <base-input
            v-if="data.user && data.user.user && data.user.user.email"
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.email')"
            v-model.trim="data.user.user.email"
            disabled
          />
          <!-- End:: Advertiser Email -->

          <!-- Start:: Landlord Type -->
          <base-input
            v-if="data.user && data.user.user"
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.landlord_type')"
            v-model.trim="data._advertiser_type"
            disabled
          />
          <!-- v-model.trim="data.user.user._landlord_type" -->
          <!-- End:: Landlord Type -->

          <!-- Start:: Documents Section -->
          <div class="col-12 mt-4 mb-3">
            <h5
              style="
                color: #404b3e;
                border-bottom: 2px solid #404b3e;
                padding-bottom: 10px;
              "
            >
              {{ $t("TITLES.documents") }}
            </h5>
          </div>

          <!-- Start:: Ownership Deed -->
          <div class="col-6 mb-4" v-if="data.ownership_deed">
            <h6 style="color: #404b3e; margin-bottom: 15px">
              {{ $t("PLACEHOLDERS.ownership_deed") }}
            </h6>
            <div class="preview-container text-center">
              <a :href="data.ownership_deed" target="_blank" class="btn">
                <i class="fal fa-download"></i>
                {{ $t("BUTTONS.view_document") }}
              </a>
            </div>
          </div>
          <!-- End:: Ownership Deed -->

          <!-- Start:: Agency Deed -->
          <div class="col-6 mb-4" v-if="data.agency_deed">
            <h6 style="color: #404b3e; margin-bottom: 15px">
              {{ $t("PLACEHOLDERS.agency_deed") }}
            </h6>
            <div class="preview-container text-center">
              <a :href="data.agency_deed" target="_blank" class="btn">
                <i class="fal fa-download"></i>
                {{ $t("BUTTONS.view_document") }}
              </a>
            </div>
          </div>
          <!-- End:: Agency Deed -->

          <!-- Start:: Images Section -->
          <div class="col-12 mt-4 mb-3">
            <h5
              style="
                color: #404b3e;
                border-bottom: 2px solid #404b3e;
                padding-bottom: 10px;
              "
            >
              {{ $t("TITLES.ad_images") }}
            </h5>
          </div>

          <!-- Start:: Ad Images -->
          <div class="col-12 mb-4" v-if="data.images && data.images.length">
            <div class="row">
              <div
                class="col-4 mb-3"
                v-for="image in data.images"
                :key="image.id"
              >
                <img
                  :src="image.image"
                  :alt="data.name"
                  style="
                    width: 100%;
                    height: 200px;
                    object-fit: cover;
                    border-radius: 8px;
                    cursor: pointer;
                  "
                  @click="openImageModal(image.image)"
                />
              </div>
            </div>
          </div>
          <div class="col-12 mb-4" v-else>
            <p class="text-muted text-center">
              {{ $t("MESSAGES.no_images_available") }}
            </p>
          </div>
          <!-- End:: Ad Images -->

          <!-- Start:: Action Buttons -->
          <div
            class="col-12 mt-4 d-flex justify-content-center gap-3"
            v-if="data.status === 'pending'"
          >
            <v-btn
              class="success"
              @click="acceptRequest"
              :disabled="isWaitingRequest"
            >
              <i class="fal fa-check"></i>
              {{ $t("BUTTONS.accept") }}
            </v-btn>
            <v-btn
              class="error"
              @click="openRejectModal"
              :disabled="isWaitingRequest"
            >
              <i class="fal fa-times"></i>
              {{ $t("BUTTONS.reject") }}
            </v-btn>
          </div>
          <!-- End:: Action Buttons -->
        </div>
      </form>
    </div>

    <!-- Start:: Image Modal -->
    <v-dialog v-model="imageModalIsOpen" max-width="800">
      <v-card>
        <v-card-text class="text-center">
          <img :src="selectedImage" style="max-width: 100%; max-height: 80vh" />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="modal_cancel_btn" @click="imageModalIsOpen = false">
            {{ $t("BUTTONS.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End:: Image Modal -->

    <!-- Start:: Reject Reason Modal -->
    <v-dialog v-model="rejectModalIsOpen" max-width="500">
      <v-card>
        <v-card-title class="text-h5 justify-center">
          {{ $t("TITLES.reject_reason") }}
        </v-card-title>
        <v-card-text>
          <base-input
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.reject_reason')"
            v-model.trim="rejectReason"
            required
          />
        </v-card-text>
        <v-card-actions>
          <v-btn
            class="modal_confirm_btn"
            @click="confirmReject"
            :disabled="!rejectReason || isWaitingRequest"
          >
            {{ $t("BUTTONS.confirm") }}
          </v-btn>
          <v-btn
            class="modal_cancel_btn"
            @click="closeRejectModal"
            :disabled="isWaitingRequest"
          >
            {{ $t("BUTTONS.cancel") }}
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End:: Reject Reason Modal -->
  </div>
</template>

<script>
import { mapActions } from "vuex";
import MapComponent from "@/components/general/MapComponent.vue";

export default {
  name: "ShowAdRequest",

  components: {
    MapComponent,
  },

  data() {
    return {
      // Start:: Loading Data
      isWaitingRequest: false,
      // End:: Loading Data

      // Start:: Data
      data: {},
      selectedAllowedActivities: [],
      selectedBlockedActivities: [],
      // End:: Data

      // Start:: Image Modal Data
      imageModalIsOpen: false,
      selectedImage: null,
      // End:: Image Modal Data

      // Start:: Reject Modal Data
      rejectModalIsOpen: false,
      rejectReason: "",
      // End:: Reject Modal Data
    };
  },

  methods: {
    // Start:: Vuex Actions
    ...mapActions({
      updateAppLoadingStatus: "LoadingModule/updateAppLoadingStatus",
    }),
    // End:: Vuex Actions

    // Start:: Get Data
    async getData() {
      this.updateAppLoadingStatus(true);

      try {
        let res = await this.$axios({
          method: "GET",
          url: `ads/${this.$route.params.id}`,
        });
        this.updateAppLoadingStatus(false);
        this.data = res.data.data.ad;

        // Populate selected activities
        if (this.data.allowed_activities) {
          this.selectedAllowedActivities = this.data.allowed_activities;
        }
        if (this.data.blocked_activities) {
          this.selectedBlockedActivities = this.data.blocked_activities;
        }
      } catch (error) {
        this.updateAppLoadingStatus(false);
        console.log(error.response?.data?.message);
        this.$message.error(
          error.response?.data?.message || this.$t("MESSAGES.failed")
        );
      }
    },
    // End:: Get Data

    // Start:: Open Image Modal
    openImageModal(imageSrc) {
      this.selectedImage = imageSrc;
      this.imageModalIsOpen = true;
    },
    // End:: Open Image Modal

    // Start:: Accept Request
    async acceptRequest() {
      this.isWaitingRequest = true;
      this.updateAppLoadingStatus(true);

      try {
        await this.$axios({
          method: "POST",
          url: `ads/requests/${this.$route.params.id}/accept`,
        });

        this.$message.success(this.$t("MESSAGES.acceptedSuccessfully"));

        this.isWaitingRequest = false;
        this.updateAppLoadingStatus(false);
        this.$router.push({ path: "/ad-requests/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.updateAppLoadingStatus(false);
        this.$message.error(
          error.response?.data?.message || this.$t("MESSAGES.failed")
        );
      }
    },
    // End:: Accept Request

    // Start:: Open Reject Modal
    openRejectModal() {
      this.rejectReason = "";
      this.rejectModalIsOpen = true;
    },
    // End:: Open Reject Modal

    // Start:: Close Reject Modal
    closeRejectModal() {
      this.rejectModalIsOpen = false;
      this.rejectReason = "";
    },
    // End:: Close Reject Modal

    // Start:: Confirm Reject
    async confirmReject() {
      if (!this.rejectReason) {
        this.$message.error(this.$t("MESSAGES.reject_reason_required"));
        return;
      }

      this.isWaitingRequest = true;
      this.updateAppLoadingStatus(true);

      try {
        await this.$axios({
          method: "POST",
          url: `ads/requests/${this.$route.params.id}/reject`,
          data: {
            reason: this.rejectReason,
          },
        });

        this.$message.success(this.$t("MESSAGES.rejectedSuccessfully"));

        this.isWaitingRequest = false;
        this.updateAppLoadingStatus(false);
        this.closeRejectModal();
        this.$router.push({ path: "/ad-requests/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.updateAppLoadingStatus(false);
        this.$message.error(
          error.response?.data?.message || this.$t("MESSAGES.failed")
        );
      }
    },
    // End:: Confirm Reject
  },

  created() {
    this.getData();
  },
};
</script>
